import { render, staticRenderFns } from "./BranchOfficeView.vue?vue&type=template&id=2da90cc0"
import script from "./BranchOfficeView.vue?vue&type=script&lang=js"
export * from "./BranchOfficeView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports